"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var helpers_1 = require("./helpers");
var styles_1 = require("./styles");
function Avatar(_a) {
    var _b = _a.height, height = _b === void 0 ? 24 : _b, _c = _a.withInitials, withInitials = _c === void 0 ? false : _c, props = __rest(_a, ["height", "withInitials"]);
    var childrenProps = helpers_1.getAvatarChildrenProps(__assign({ withInitials: withInitials,
        height: height }, props));
    var children = props.src ? (react_1.default.createElement(styles_1.AvatarImg, __assign({}, childrenProps))) : (react_1.default.createElement(styles_1.AvatarFallback, __assign({}, childrenProps)));
    return react_1.default.createElement(react_1.default.Fragment, null, children);
}
exports.default = Avatar;
//# sourceMappingURL=index.js.map